var path = '/static/assets/khapps/dss/dss_pestdisease/osr_sclerotinia/ChartConfiguration.html';
var html = "<div ng-if=\"show_data\">\n    <highchart config=\"risk_chart\"></highchart>\n    <highchart config=\"weather_chart\"></highchart>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;